export default "__VITE_ASSET__BZriPJt5__"